import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { GasOptions, GlassOptions, LogicItem, Option } from '../app.model';
import { Observable, of } from 'rxjs';
import { ENERGY_EFFICIENCY } from './energy-efficiency.const';

@Component({
  selector: 'app-energy-efficiency',
  standalone: true,
  imports: [
    CommonModule,
    MainLayoutComponent,
  ],
  templateUrl: './energy-efficiency.component.html',
  styleUrl: './energy-efficiency.component.scss',
})
export class EnergyEfficiencyComponent implements OnInit {
  glassOptions: GlassOptions = ENERGY_EFFICIENCY.glassOptions;
  gasOptions: GasOptions = ENERGY_EFFICIENCY.gasOptions;
  logicMap: LogicItem[] = ENERGY_EFFICIENCY.logicMap;
  uValue = {
    image: '',
    value: '',
  };

  constructor() {}

  ngOnInit() {
    this.setupUValue();
  }

  onSelect(item: Option, list) {
    if (!item.selected) {
      const listItem = list.split(' ');
      if (listItem) {
        this[listItem[0]][listItem[1]].map((listItem) =>
          item.unique_name === listItem.unique_name
            ? (listItem.selected = !listItem.selected)
            : (listItem.selected = false)
        );
        this.setupUValue();
      }
    }
  }

  setupUValue() {
    const glassOption = this.glassOptions.glassOptionsList.find(
      (item: Option) => item.selected
    ).unique_name;
    const gas = this.gasOptions.gasOptionsList.find(
      (item: Option) => item.selected
    ).unique_name;
    const key = `${glassOption} ${gas}`;

    const obj = this.logicMap.find(
      (item: LogicItem) => item.unique_names_combination === key
    );
    if (obj) {
      this.uValue.image = obj.image.url;
      this.uValue.value = obj.uvalue;
    }
  }

  onClickBack = (): Observable<any> => {
    return of(true);
  };
}
